import ButtonMain from "components/Common/Button"
import {
  addImagingRequest,
  BASE,
  getAllPetsByParentId,
  getImagingAndLabsBasedOnId,
  updateImagingRequest,
  uploadAttachment,
} from "helpers/api_helper"
import Type from "../Appointments/Type"
import {
  modifyAppointmentType,
  modifyParentType,
  modifyTestType,
  modifyTestTypeOptions,
} from "helpers/utils"
import * as Yup from "yup"
import { useFormik } from "formik"

import { use } from "i18next"
import React, { useEffect, useReducer, useState } from "react"
import { Link, useHistory, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { showMessage } from "components/Notification"
import ReactSelect from "react-select"
import {
  getAllParents,
  getParentList,
  getpricing,
  getPricingDetails,
  getUserDetails,
  setGlobalLoading,
} from "store/slices"
import { useDispatch, useSelector } from "react-redux"
import LeftArrow from "../../assets/icons/ArrowLeft.png"

const CreatePatient = () => {
  //meta title
  document.title = "Labs Request"
  // const appointmentType = useSelector(getServices)
  const [isLoading, setIsLoading] = useState(false)
  const [details, setDetails] = useState({})

  const [selectedPet, setSelectedPet] = useState({})
  const [allPets, setAllPets] = useState([])
  const [currentPet, setCurrentSelectedPet] = useState({})
  const [isFetchingPets, setIsFetchingPets] = useState(false)
  const [addPet, setAddPet] = useState(false)
  const parentsList = useSelector(getAllParents)
  const userDetails = useSelector(getUserDetails)

  const [testType, settestType] = useState()
  const [testName, setTestName] = useState(null)
  const [selectedParent, setSelectedParent] = useState({})
  const [typeOfModal, setTypeOfModal] = useState("")
  const [patientTests, setPatientTests] = useState(details?.labTests || [])
  const [modal, setModal] = useState(false)
  const [isFileUploading, setIsFileUploading] = useState(false)
  const [selectedStatus, setStatus] = useState({
    label: "Requested",
    value: "Requested",
  })
  const [pricing, setPricing] = useState(null)
  const [selectedFiles, setselectedFiles] = useState([])
  const [ImageUrls, setImageUrl] = useState([])
  const [formType, setFormType] = useState(null);
  const { labId } = useParams()

  const dispatch = useDispatch()


  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const typeParam = searchParams.get('type') || "";
    if(typeParam.trim().length) {
      dispatch(setGlobalLoading(true))
    }
    setFormType(typeParam.trim());
  }, []);
  
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      type: details?.type || "",
      notes: details?.notes || "",
      result: details?.result || "",
      name: details?.name || "",
      pricing: details?.pricing || "",
    },
    validationSchema: Yup.object({
      // type: Yup.string().required("Please Enter labs type"),
      // notes: Yup.string().required("Please Enter Notes"),
      ...(labId && formType === "update"
        ? { result: Yup.string().required("Please Enter Result") }
        : {}),
    }),
    onSubmit: async values => {
      if (!currentPet._id && formType === "update") {
        showMessage({ label: "Please Select Parent and Pet", status: "info" })
        return
      }
      // if (!patientTests?.length && formType === "update") {
      //   showMessage({ label: "Please Add tests", status: "info" })
      //   return
      // }
      if (!testType && formType === "update") {
        showMessage({ label: "Please Select Test Type", status: "info" })
        return
      }
      if (!testName && formType === "update") {
        showMessage({ label: "Please Select Test Name", status: "info" })
        return
      }
      if (!values.notes && formType === "update") {
        showMessage({
          label: `Please add notes`,
          status: "warning",
        })
        return
      }
      const obj = {
        ...values,
        status: "Requested",
        scansOrReports: ImageUrls,
        testType: "labs",
        type: testType.value,
        labTests: patientTests,
        name: testName.value,
        pricing: pricing,
      }
      obj.petObjectId = selectedPet.value
      obj.parentId = selectedParent.value
      obj.doctorId = userDetails._id
      if (labId) {
        obj.reportId = labId
      }

      if(formType.trim() === "edit") {
        handleEditlabRequest(obj)
      } else {
        handleSubmit(obj)
      }
    },
  })

  const history = useHistory()
  useEffect(() => {
    async function fetchData() {
      if (!labId) return
      // dispatch(setGlobalLoading(true))
      const _detail = await getImagingAndLabsBasedOnId({
        reportId: labId,
        type: "labs",
      })
      setDetails(_detail.data)
      console.log("labTests", _detail)
      // setTimeout(() => {
      setPatientTests(_detail?.data.labTests || [])
      // }, 100);

      // dispatch(setGlobalLoading(true))
      setTimeout(() => {
        setSelectedParent({
          label: _detail?.data.parentId?.fullName,
          value:
            _detail?.data.parentId?._id || _detail?.data.petObjectId?.parentId,
        })
        handleLoadPetData({
          label: _detail?.data.parentId?.fullName,
          value:
            _detail?.data.parentId?._id || _detail?.data.petObjectId?.parentId,
        })
        setSelectedPet({
          label: _detail?.data.petObjectId?.fullName,
          value: _detail?.data.petObjectId?._id,
        })
        settestType({
          label: _detail?.data.type,
          value: _detail?.data.type,
        })
        setTestName({
          label: _detail?.data.name,
          value: _detail?.data.name,
        })
        setCurrentSelectedPet({ ..._detail?.data.petObjectId })
        setPricing(_detail?.data.pricing)
        dispatch(setGlobalLoading(false))
      }, 1000)
    }
    fetchData()
  }, [labId])

  const handleSubmit = async values => {
    console.log(values)
    // return
    try {
      setIsLoading(true)
      let res
      if (!labId) {
        res = await addImagingRequest(values)
      } else {
        res = await updateImagingRequest({ ...values, status: "Completed" })
      }

      if (res.status === 1) {
        showMessage({ label: res.message, status: "success" })
        history.push(labId ? "/labs-completed" : "/lab-requests")
      } else {
        showMessage({
          label: res.message || "something went wrong",
          status: "error",
        })
      }
      setIsLoading(false)
    } catch (error) {
      showMessage({
        label: error.response.data.message || "something went wrong",
        status: "error",
      })
      setIsLoading(false)
    }
  }

  const handleEditlabRequest = async (values) => {
    try {
      setIsLoading(true)
      const res = await updateImagingRequest({ ...values, status: "Requested" })
      
      if (res.status === 1) {
        showMessage({ label: res.message, status: "success" })
      } else {
        showMessage({
          label: res.message || "something went wrong",
          status: "error",
        })
      }
      
      setIsLoading(false)
    } catch(error) {
      console.error("Error in handleEditlabRequest:", error);
    }
  }

  const handleSelectedParent = async item => {
   await handleLoadPetData(item);
   setSelectedPet(null)
  }

  const handleLoadPetData = async (item) => {
    setSelectedParent(item)
    // setIsFetchingPets(true)
    const response = await getAllPetsByParentId(item.value)
    if (response.status == 1) {
      if (response.data?.length) {
        setAllPets(response.data)
        setIsFetchingPets(false)
        setAddPet(false)
      } else {
        showMessage({
          label: `No pets found for ${item.label} parent`,
          status: "info",
        })
        setAddPet(true)
        setAllPets([])
      }
    }
    // setIsFetchingPets(false)
    return response.data
  }


  const handleSelectedPet = async (item, petlist = null) => {
    setSelectedPet(item)
    const selected = [...(petlist?.length ? petlist : allPets)].find(
      ele => ele._id === item.value
    )
    setCurrentSelectedPet(selected)
  }

  useEffect(() => {
    async function newLoad() {
      // dispatch(setGlobalLoading(true))
      await dispatch(getParentList({ doctorId: userDetails._id }))
      // dispatch(setGlobalLoading(false))
    }
    newLoad()
  }, [dispatch])

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const handleStatus = item => {
    setStatus(item)
    validation.handleChange(item.label)
  }
  const handleUploadScans = async event => {
    try {
      setIsFileUploading(true)
      const file = event.target.files[0]

      if (!file) {
        showMessage({ label: "Please select a file", status: "error" })
        setIsFileUploading(false)
        return
      }

      // Add file type check here
      const allowedFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
        "application/vnd.ms-excel" // .xls files
      ];

      if (!allowedFileTypes.includes(file.type)) {
        showMessage({ label: "Invalid file type", status: "error" })
        setIsFileUploading(false)
        return
      }

      const formData = new FormData()

      formData.append("files", event.target.files[0])
      const response = await uploadAttachment(formData)
      if (response.status === 1) {
        showMessage({
          label: `Uploaded Successfully! Please press confirm  to continue`,
          status: "success",
        })
        const imageUrl = [...ImageUrls]
        imageUrl.push(response.data[0])
        setImageUrl(imageUrl)
      }

      setIsFileUploading(false)
    } catch (error) {
      console.log(error)
      setIsFileUploading(false)
      showMessage({ label: "File Size is too big", status: "error" })
    }
  }
  const FileUpload = () => {
    return (
      <div className="file-upload-container mb-4">
        {ImageUrls?.length
          ? ImageUrls.map((item, index) => (
              <div key={index} className="file-upload-image-container">
                <div
                  className="file-upload-image-delete"
                  onClick={() => {
                    const imageUrl = [...ImageUrls]
                    imageUrl.splice(index, 1)
                    setImageUrl(imageUrl)
                  }}
                >
                  X
                </div>
                <img className="file-upload-image" src={item} />
              </div>
            ))
          : null}
        <div className="d-flex align-items-center">
          <div className="file-upload-square">
            +<br />
            Upload Scan
            <input
              type="file"
              onChange={handleUploadScans}
              accept="*"
              className="form-control"
            />
          </div>
          <p className="upload-instructions">
            Allowed file types: PDF, DOC, DOCX
          </p>
        </div>
      </div>
    )
  }
  const handlePatientTestsDelete = index => {
    const _patientTests = [...patientTests]
    _patientTests.splice(index, 1)
    setPatientTests(_patientTests)
  }

  const renderTests = () => {
    return (
      <div className="cell-tag-container">
        {patientTests?.length ? (
          <>
            <h6>Tests:</h6>
            <div className="cell-tags-roe">
              {patientTests.map(({ title }, index) => {
                return (
                  <div key={`${title}-${index}`} className="cell-tags">
                    <button
                      className="cell-tag-close"
                      onClick={() => handlePatientTestsDelete(index)}
                    >
                      x
                    </button>
                    {title}
                  </div>
                )
              })}
            </div>
          </>
        ) : null}
      </div>
    )
  }

  const handleDataSet = data => {
    const _patientTests = [...patientTests]
    _patientTests.push(data)
    setPatientTests(_patientTests)

    setTypeOfModal("")
  }
  const handleOpenModal = type => {
    setTypeOfModal(type)
  }

  // const LabTestTypeOptions = [
  //   {
  //     value: "Hematology",
  //     label: "Hematology",
  //   },
  //   { value: "Clinical Chemistry", label: "Clinical Chemistry" },
  //   { value: "Clinical Pathology", label: "Clinical Pathology" },
  //   { value: "Parasitology", label: "Parasitology" },
  //   { value: "Infectious Diseases", label: "Infectious Diseases" },
  //   { value: "Coagulation Disorders", label: "Coagulation Disorders" },
  //   { value: "Endocrinology", label: "Endocrinology" },
  //   { value: "Inflammation", label: "Inflammation" },
  //   { value: "Musculoskeletal", label: "Musculoskeletal" },
  //   { value: "Musculoskeletal", label: "Musculoskeletal" },
  //   { value: "Ultrasonography", label: "Ultrasonography" },
  //   { value: "Gastroenterology", label: "Gastroenterology" },
  //   { value: "Parasitology", label: "Parasitology" },
  // ]

  useEffect(() => {
    async function fetchPricingData() {
      if (userDetails?._id) {
        // dispatch(setGlobalLoading(true))
        await dispatch(getPricingDetails({ vetId: userDetails?._id }))
        // dispatch(setGlobalLoading(false))
      }
    }
    fetchPricingData()
  }, [dispatch])

  const dummyAppointment = useSelector(getpricing)
  const filterPricingOptions = dummyAppointment
    .filter(ele => ele.category.pricingCategoryName === "Lab Pricing")
    .filter(ele => ele.testingType === testType?.value)

  const LabTestTypeOption1 = dummyAppointment
    .filter(ele => ele.category.pricingCategoryName === "Lab Pricing")
    .filter((obj, index, array) => {
      const firstIndex = array.findIndex(
        item => item.testingType === obj.testingType
      )
      return index === firstIndex
    })
  const LabTestTypeOptions = modifyTestTypeOptions(LabTestTypeOption1)

  const handleLabTypeMenuOpen = () => {
    setTimeout(() => {
      if (LabTestTypeOptions.length === 0) {
        showMessage({
          label: "No Tests Available! Need to Create First",
          status: "info",
        })
      }
    }, 1000)
  }

  const handleParentListMenuOpen = () => {
    setTimeout(() => {
      if (parentsList.length === 0) {
        showMessage({
          label: "No Parents Available! Need to Create First",
          status: "info",
        })
      }
    }, 1000)
  }

  const handleTestNameChange = selectedOption => {
    setTestName(selectedOption)
    setPricing(selectedOption?.pricing)
  }

  const handleSelectTestType = (value) => {
    settestType(value);
    setTestName(null);
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="mx-2 mb-4 ">
            <Col className="d-flex align-items-center justify-content-start gap-2">
              <img
                src={LeftArrow}
                width={32}
                onClick={() => history.goBack()}
                role="button"
              />
              <h4 className="mb-0 font-fontFamily fontSize-28">
                New Labs Request
              </h4>
            </Col>

            <Col className="d-flex align-items-center justify-content-between gap-4"></Col>
            <div className="create-link">
              <Link
                color="primary"
                className="font-16 btn-block"
                to={"/add-pricing/Lab%20Pricing"}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Add Test Type
              </Link>
            </div>
          </Row>
          {/* <Breadcrumbs
            title="Labs"
            titleLink="/labs-requests"
            breadcrumbItem={"Labs Request"}
          /> */}
          {typeOfModal && (
            <Type
              type={typeOfModal}
              onConfirm={handleDataSet}
              onCloseClick={() => {
                setTypeOfModal("")
              }}
            />
          )}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <CardTitle className="mb-4">Pet parent details</CardTitle> */}
                  <Form
                    onSubmit={validation.handleSubmit}
                  >
                    {/* <Row> */}
                    <Row className="justify-content-end mt-8">
                      <Col lg={6}>
                        <FormGroup className="row mb-9">
                          <Label className="col-form-label col-lg-4 text-lg-end text-start text-input-label font-fontFamily-400">
                            Pet Parent<span className="text-danger">*</span>
                          </Label>
                          <div className="col-lg-8">
                            <ReactSelect
                              value={selectedParent}
                              onChange={handleSelectedParent}
                              isDisabled={!!labId && formType === "update"}
                              options={modifyParentType(parentsList)}
                              classNamePrefix="form-react-select"
                              className="form-react-select"
                              onMenuOpen={handleParentListMenuOpen}
                            />
                          </div>
                        </FormGroup>
                        {addPet && (
                          <div className="history-doc-cta mb-3 ">
                            <Link
                              className="btn btn-primary"
                              to={`/add-pet/parent/${selectedParent?.value}`}
                            >
                              + Add Pet
                            </Link>
                          </div>
                        )}
                        <FormGroup className="row mb-3">
                          <Label className="col-form-label col-lg-4 text-lg-end text-start text-input-label font-fontFamily-400">
                            Pet<span className="text-danger">*</span>
                          </Label>
                          <div className="col-lg-8">
                            <ReactSelect
                              value={selectedPet}
                              isDisabled={!allPets.length || isFetchingPets || formType === "update"}
                              onChange={handleSelectedPet}
                              options={modifyAppointmentType(allPets)}
                              classNamePrefix="form-react-select"
                              className="form-react-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup className="row mb-3">
                          <Label className="col-form-label col-lg-4 text-lg-end text-start text-input-label font-fontFamily-400">
                            Test Type<span className="text-danger">*</span>
                          </Label>
                          <div className="col-lg-8">
                            <ReactSelect
                              name="type"
                              value={testType}
                              onChange={handleSelectTestType}
                              isDisabled={!!labId && formType === "update"}
                              options={LabTestTypeOptions}
                              classNamePrefix="form-react-select"
                              className="form-react-select"
                              onMenuOpen={handleLabTypeMenuOpen}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup className="row mb-3">
                          <Label className="col-form-label col-lg-4 text-lg-end text-start text-input-label font-fontFamily-400">
                            Select Test<span className="text-danger">*</span>
                          </Label>
                          <div className="col-lg-8">
                            <ReactSelect
                              name="testName"
                              value={testName}
                              onChange={handleTestNameChange}
                              isDisabled={!!labId && formType === "update"}
                              options={modifyTestType(filterPricingOptions)}
                              classNamePrefix="form-react-select"
                              className="form-react-select"
                            />
                          </div>
                        </FormGroup>
                        {labId && formType === "update" && (
                          <FormGroup className="mb-3 row">
                            <Label
                              htmlFor="projectdesc"
                              className="col-form-label col-lg-4 text-lg-end text-start text-input-label font-fontFamily-400"
                            >
                              Result
                            </Label>
                            <div className="col-lg-8">
                              <Input
                                id="result"
                                name="result"
                                type="text"
                                className="form-control"
                                placeholder="Result"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.result || ""}
                                invalid={
                                  validation.touched.result &&
                                  validation.errors.result
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.result &&
                              validation.errors.result ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.result}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>
                    {labId && formType === "update" && (
                      <Row className="justify-content-end mt-8 mb-3">
                        <Col lg={10}>
                          <Label className="col-form-label text-input-label">
                            Add Reports
                          </Label>
                          <Form>
                            <FileUpload />
                          </Form>
                        </Col>
                      </Row>
                    )}
                    <Row className="justify-content-end mt-3">
                      <Col lg="12">
                        <FormGroup className="mb-4" row>
                          <Label
                            htmlFor="projectdesc"
                            className="col-form-label col-lg-2 text-lg-end text-start text-input-label font-fontFamily-400"
                          >
                            Notes
                          </Label>
                          <div className="col-lg-10">
                            <textarea
                              className="form-control"
                              id="projectdesc"
                              rows="8"
                              name="notes"
                              style={{ resize: "none", minHeight: 200 }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.notes || ""}
                              placeholder="Notes"
                            />
                            {validation.touched.notes &&
                            validation.errors.notes ? (
                              <FormFeedback type="invalid">
                                {validation.errors.notes}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </FormGroup>
                        <FormGroup className="mb-4  justify-content-end " row>
                          <span className="gray-note">
                            To Pay :
                            <span className="gray-note--primary">
                              INR {pricing}
                            </span>
                          </span>
                        </FormGroup>
                        <div className="d-flex justify-content-end">
                          <ButtonMain
                            isLoading={isLoading}
                            type="submit"
                            className="btn btn-primary"
                          >
                            {labId ? formType === "edit" ? "Save Changes": "Complete" : "Create Request"}
                          </ButtonMain>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreatePatient
